export default __webpack_public_path__ + "images/XQ.220b1ea.png";